$(document).ready(function() {

  document.addEventListener("easyorder_popup_after_open", function(event) {
    var herodispatch_data = "#herodispatch_data";
    $('#easyorder-field-element-89006').val($(herodispatch_data).data('email'));
    $('#easyorder-field-element-89027').val($(herodispatch_data).data('address'));
    $('#easyorder-field-element-89065').val($(herodispatch_data).data('phone'));
    var vetGramsInput = document.querySelector('#cart_grams_total');
    var vetGrams = vetGramsInput.getAttribute('data-cart-grams-total');
    $('#easyorder-field-element-90705').val(vetGrams);
    
  });
  
  if ($("#cart_grams_total")[0]) {
    if ($("#easyorder-field-element-89006")[0]) {
      document.getElementById("easyorder-field-element-89006").setAttribute("readonly", "true");
      document.getElementById("easyorder-field-element-89027").setAttribute("readonly", "true");
      document.getElementById("easyorder-field-element-90705").setAttribute("readonly", "true");
      $("#easyorder-field-element-89065").attr("class", "phone");
      $("#easyorder-field-element-89065").attr('data-mask', '000-000-0000');
    }    
    var shippingAddress = document.getElementById("easyorder-field-89027");
    shippingAddress.innerHTML += "<p class='mb-2'><i class='fa fa-question-circle' aria-hidden='true'></i> <a target='_blank' href='https://help.herodispatch.com/article/121-how-do-i-update-my-shipping-address'>How do I update my Shipping Address?</a></p>"
  }
});